module.exports = __webpack_public_path__ + "static/img/7.1234c40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/7.png
// module id = IdNo
// module chunks = 0